module.exports = __webpack_public_path__ + "static/media/sliderImage5.a26bc8ee.jpg";